import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
/** 
 * Anywhere Teacher 2.0 Theme - Development Frontend
 */
const theme = createTheme({
	palette: {
		primary: {
			main: '#165893',
		},
		secondary: {
			main: '#19857b',
		},
		error: {
			main: red.A400,
		},
		mode: "light",
	},
});

export default theme;
